<template>
  <div id="domain-detail" v-if="detail.id !== ''">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'Domain'|t }}:</td>
        <td>{{ detail.domain }}</td>
      </tr>
      <tr>
        <td>{{ 'Status'|t }}:</td>
        <td v-html="detail.status.join('<br>')"></td>
      </tr>
      <tr>
        <td>{{ 'Authentication information'|t }}:</td>
        <td><i class="icon icon-eye hover-help" :title="detail.authid"></i></td>
      </tr>
      <tr>
        <td>{{ 'Created'|t }}:</td>
        <td>{{ $options.filters.date(detail.created_at) }}</td>
      </tr>
      <tr>
        <td>{{ 'Updated'|t }}:</td>
        <td>{{ $options.filters.date(detail.updated_at) }}</td>
      </tr>
      <tr>
        <td>{{ 'Expiration date'|t }}:</td>
        <td>{{ detail.expire_at|date }}</td>
      </tr>
      <tr>
        <td>{{ 'Transfer date'|t }}:</td>
        <td>{{ detail.transfer_at|date }}</td>
      </tr>
      <tr>
        <td>{{ 'Current registrar'|t }}:</td>
          <td><RouteLabelConverter v-bind="registrarLabelProps(detail.owner_rid)"></RouteLabelConverter></td>
      </tr>
      <tr>
        <td>{{ 'Owner contact'|t }}:</td>
        <td><RouteLabelConverter v-bind="contactLabelProps(detail.owner_id)"></RouteLabelConverter></td>
      </tr>
      <tr>
        <td>{{ 'Admin contact'|t }}:</td>
        <td><RouteLabelConverter v-bind="contactLabelProps(detail.admin_id)"></RouteLabelConverter></td>
      <tr>
        <td>{{ 'Tech contact'|t }}:</td>
        <td><RouteLabelConverter v-bind="contactLabelProps(detail.tech_id)"></RouteLabelConverter></td>
      </tr>
      <tr>
        <td>{{ 'Billing contact'|t }}:</td>
        <td><RouteLabelConverter v-bind="contactLabelProps(detail.billing_id)"></RouteLabelConverter></td>
      </tr>
      <tr v-if="detail.nameservers && detail.nameservers.length > 0">
        <td>{{ 'Name servers'|t }}:</td>
        <td>
          <router-link v-for="ns in detail.nameservers" :key="ns" :to="{ name: 'host.update', params: { name: ns } }" tag="div"><a>{{ ns }}</a></router-link>
        </td>
      </tr>
      </tbody>
    </table>

    <table v-if="showRGP" class="unstriped">
      <caption>RGP</caption>
      <tbody>
        <tr>
          <td>{{ 'RGP status'|t }}:</td>
          <td>{{ detail.extensions.rgp.status }}</td>
        </tr>
        <tr>
          <td>{{ 'RGP expires'|t }}:</td>
          <td>{{ detail.extensions.rgp.elapses|date }}</td>
        </tr>
        <tr>
          <td>{{ 'RGP created date'|t }}:</td>
          <td>{{ detail.extensions.rgp.delete_date|date }}</td>
        </tr>
      </tbody>
    </table>

    <table v-if="showDNS" class="unstriped">
      <caption>DNS SEC</caption>
      <thead>
        <tr>
          <td>DS Algorithm</td>
          <td>DS Key Tag</td>
          <td>DS Digest Type</td>
          <td>DS Digest</td>
          <td>Key Algorithm</td>
          <td>Key Flags</td>
          <td>Key Protocol</td>
          <td>Key Public Key</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dns in detail.extensions.dns_keys.ds_data">
          <td>{{ dns.alg }}</td>
          <td>{{ dns.key_tag }}</td>
          <td>{{ dns.digest_type }}</td>
          <td :colspan="dns.key_data ? '1' : '5'">{{ dns.digest_value }}</td>
          <td v-if="dns.key_data">{{ dns.key_data.alg }}</td>
          <td v-if="dns.key_data">{{ dns.key_data.flags }}</td>
          <td v-if="dns.key_data">{{ dns.key_data.proto }}</td>
          <td v-if="dns.key_data"><i class="icon icon-eye hover-help" :title="dns.key_data.public_key"></i></td>
        </tr>
        <tr v-for="dns in detail.extensions.dns_keys.key_data">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ dns.alg }}</td>
          <td>{{ dns.flags }}</td>
          <td>{{ dns.proto }}</td>
          <td><i class="icon icon-eye hover-help" :title="dns.public_key"></i></td>
        </tr>
      </tbody>
    </table>

  </div>
</template>
<script>
  import api from '@/api';
  import RouteLabelConverter from '@/components/RouteLabelConverter';

  export default {
    name: 'Detail',
    components: {
      RouteLabelConverter
    },
    props: {
      domain: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        detail: {
          id: ""
        }
      }
    },
    created() {
      api.viewDomain(
        { name: this.domain },
        data => this.detail = data
      )
    },
    computed: {
      showRGP() {
        return this.detail !== null && this.detail.hasOwnProperty("extensions") && this.detail.extensions.hasOwnProperty("rgp") && this.detail.extensions.rgp !== null;
      },
      showDNS() {
        return this.detail !== null && this.detail.hasOwnProperty("extensions") && this.detail.extensions.hasOwnProperty("dns_keys") && this.detail.extensions.dns_keys !== null;
      }
    },
    methods: {
      contactLabelProps(id) {
        return {
          request: {contact_id: id},
          placeholder: id,
          call: "viewContact",
          handler: function(data) {
            return data.name + ", " + data.org;
          },
          route: {
            to: {
              name: "contact.view",
              params: {
                id: id,
              },
            },
          }
        }
      },
      registrarLabelProps(id) {
        return {
          request: {registrar_id: id},
          placeholder: id,
          call: "viewRegistrar",
          handler: function(data) {
            return data.name + ", " + data.org;
          },
          route: {
            to: {
              name: "registrar.view",
              params: {
                id: id,
              },
            },
          }
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/domain/Detail.vue